/**
 * Persistent notification toasts — used for VB6 transfer reminders
 * and excessive label reprint alerts.
 */
import React from 'react';
import toast from 'react-hot-toast';
import { AlertTriangle, Printer, X } from 'lucide-react';

interface Props {
  toastId: string;
  label: string;
  detail: string;
  icon?: React.ReactNode;
}

const PersistentToast: React.FC<Props> = ({ toastId, label, detail, icon }) => (
  <div className="flex items-start gap-3 max-w-sm">
    {icon || <AlertTriangle className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" />}
    <div className="flex-1">
      <p className="font-semibold text-gray-900 text-sm">{label}</p>
      <p className="text-gray-600 text-sm mt-0.5">{detail}</p>
    </div>
    <button
      onClick={() => toast.dismiss(toastId)}
      className="p-1 text-gray-400 hover:text-gray-600 rounded shrink-0"
    >
      <X className="w-4 h-4" />
    </button>
  </div>
);

/** Show a persistent transfer reminder toast */
export function showTransferReminderToast(label: string, detail: string) {
  toast(
    (t) => <PersistentToast toastId={t.id} label={label} detail={detail} />,
    { duration: Infinity }
  );
}

/** Show a persistent reprint alert toast */
export function showReprintAlertToast(label: string, detail: string) {
  toast(
    (t) => <PersistentToast toastId={t.id} label={label} detail={detail} icon={<Printer className="w-5 h-5 text-red-500 shrink-0 mt-0.5" />} />,
    { duration: Infinity }
  );
}
